import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Checkbox, CheckboxField } from '@/common/components/checkbox';
import { Field, Fieldset, Label, Legend } from '@/common/components/fieldset';
import { Heading } from '@/common/components/heading';
import { Input } from '@/common/components/input';
import { Link } from '@/common/components/link';
import { Text } from '@/common/components/text';

export const Route = createFileRoute('/applications/$application-id/sign')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <div className="p-8">
      <Heading>Review Application</Heading>
      <Text>Review the Membership Application and complete information to submit application.</Text>

      <Text>Please review the <Link href="https://www.talquinelectric.com/wp-content/uploads/Talquin-Bylaws-Amended-Effective-4.29.2023-1.pdf">Bylaws</Link> and <Link href="https://www.talquinelectric.com/wp-content/uploads/Rules-and-Regulations-for-Electric-Service.pdf">Rules and Regulations</Link> available on our <Link href="https://www.talquinelectric.com/">website</Link>.</Text>

      <CheckboxField>
        <Checkbox name="agree" value="yes" />
        <Label>I confirm that I have reviewed the above information and verified it to the best of my knowledge.</Label>
      </CheckboxField>

      <Fieldset>
        <Legend>Sign & Accept</Legend>
        <Text>Acceptance of this application by Talquin shall constitute an agreement between Applicant and Talquin from the date service is made available by Talquin Electric Cooperative, Inc. and/or Talquin Water & Wastewater, Inc. to Applicant and thereafter until canceled by notice given by either party to the other.</Text>

        <Field>
          <Label>Full Name</Label>
          <Input name="fullName" />
          <Text>Please type your full name (Joseph Chester Jordan) to serve as a signature for this document.</Text>
        </Field>

        <Field>
          <Label>Date</Label>
          <Input name="date" />
        </Field>
      </Fieldset>

      <ButtonGroup>
        <Button to="/applications/$application-id/confirm" params={{ 'application-id': '1' }} outline>Back</Button>
        <Button to="/applications/$application-id/end" params={{ 'application-id': '1' }}>Submit Application</Button>
      </ButtonGroup>
    </div>
  );
}
